export enum Authority {
  ADMIN = 'ROLE_ADMIN',
  USER = 'ROLE_USER',
  MIIC_USER = 'ROLE_MIIC_USER',
  RIZOMA_USER = 'ROLE_RIZOMA_USER',
  EXTERNAL_USER = 'ROLE_EXTERNAL_USER',
  INTERNAL_USER = 'ROLE_INTERNAL_USER',
  BECAS = 'ROLE_BECAS',
  POSDOC = 'ROLE_POSDOC',
  SNI = 'ROLE_SNI',
  OPERADOR = 'ROLE_OPERADOR',
  CONFIGURADOR = 'ROLE_CONFIGURADOR',
  COORDINADOR = 'ROLE_COORDINADOR',
  DIRECTOR = 'ROLE_DIRECTOR',
  DIRECTOR_ADJUNTO = 'ROLE_DIRECTOR_ADJUNTO',
  FONDOS = 'ROLE_FONDOS_CIENCIA',
  PROYECTOS_ENCARGO = 'ROLE_PROYECTOS_ENCARGO',
  SECRETARIO_TEC = 'ROLE_SECRETARIO_TEC',
  SECRETARIO_ADMON = 'ROLE_SECRETARIO_ADMON',
  PRONACES = 'ROLE_PRONACES',
  SECRETARIO_EJECUTIVO = 'ROLE_SECRETARIO_EJECUTIVO',
  AUTORIDAD_FACULTADA = 'ROLE_AUTORIDAD_FACULTADA',
  RENAJEB = 'ROLE_RENAJEB',
}
